import shalewa from './shalewa.jpg';
import blazer from './blazer.jpeg';
import gradient_shirt from './gradient_shirt.jpg';
import oyinkan from './oyinkan.jpg';
import temi from './temi.jpg';
import yemisi from './yemisi.jpg';
import yimika from './yimika.jpg';
import adire_beachwear from './adire_beachwear.jpg';

let all_products = [
    {
        id: 1,
        name: "Yemisi Dress",
        image: yemisi,
        category: "Women",
        price: 45000,
        description:"First, a dazzling floor length silhouette of black fabric which gives timeless elegance. But then your eyes are drawn up to the exaggerated sleeves, a burst of finest quality Ankara print with shimmery threads that explodes from the neckline in a symphony of color and pattern."
      },
      {
        id: 2,
        name: "Yimika Jumpsuit",
        image: yimika,
        category: "Women",
        price: 36000,
        description:"This isn't just a jumpsuit, it's a celebration of culture and self-expression. The vibrant Adire dances across the flowing wide-leg pants, a symphony of rich hues and intricate patterns that turn heads with every step."
      },
      {
        id: 3,
        name: "Temi Midi Dress",
        image: temi,
        category: "Women",
        price: 32000,
        description:"This is no ordinary white dress. It's a conversation starter, a whispered tale of cultural heritage, royalty and finesse woven into the very fabric."
      },
      {
        id: 4,
        name: "Shalewa 2-piece",
        image: shalewa,
        category: "Women",
        price: 30000,
        description:"City girls UP! <br/> This outfit is for the urban explorer who embraces the adventure."
      },
      {
        id: 5,
        name: "Oyinkan",
        image: oyinkan,
        category: "Women",
        price: 25000,
        description:"The print is a masterpiece, a kaleidoscope of colors and patterns. Tailored to flatter your curves with the grace of a satin caress. The bell sleeves and skirted frills make this an unforgettable piece."
      },
    {
        id: 6,
        name: "YB Blazer set",
        image: blazer,
        category: 'Women',
        price: 25000,
        description:"Fit for all working women"
    },
    {
        id: 7,
        name: "PBF Gradient 2-Piece",
        image: gradient_shirt,
        category: 'Men',
        price: 20000,
        description:"Bold look for the men, ideal for a casual day out. Can be worn to the airport, errands, movies, etc. Can be sold separately"
    },
    {
        id: 8,
        name: "PBF Adire Beachwear",
        image: adire_beachwear,
        category: 'Men',
        price: 22000,
        description:"Made of the softest cotton and intricatey hand-drawn figures. This is a breezy and relaxed look. Ideal for a day out at the beach or in nature."
    },

]

export default all_products;